import React from 'react';
import AppShell from '../../components/app-shell/app-shell';
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import CalligraphyWorkshops from '../../components/landing-pages/calligraphy-workshops';
import markdown from './calligraphy-workshops.md';

export default function() {
  return (
    <AppShell
      seoTitle="Local Calligraphy Workshops"
      description="Melissa teaches local calligraphy workshops about once a month"
    >
      <PublicShell>
        <CalligraphyWorkshops />
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
